export default __webpack_public_path__ + "static/media/103.eaf01786.png";